module.exports = __webpack_public_path__ + "img/logo.681bcffc.svg";